'use client'
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { getUserId } from '@/utils/builder/userUtils';
import axios from 'axios';
import axiosObj from '@/store/axios';
import EachProductCard from './EachProductCard';
import EachDesignCard from './EachDesignCard';
import NoItemsMessage from './NoItemsMessage';
import { accordionTitleConstants } from './GetTrayComponentsForThreeDBuilder';
import { subAccordionConstants } from './GetTrayComponentsForThreeDBuilder';
import { BuilderProduct, actions as builderActions } from '@/store/builderSlice';
import { useDispatch } from 'react-redux';
import LoadingSpinner from './LoadingSpinner';
import { gtmClickTracking } from '@/utils';
interface RecentAndFavoriteProduct {
    _id: string;
    customerId: string;
    itemId: string;
    type: string;
    comparePrice: number;
    createdDate: string;
    image: string;
    model3dUrl: string;
    modifiedDate: string;
    name: string;
    price: number;
    shopifyId:string;
}
interface SubAccordionDetailsProps {
    eachAccordion: {
        id: string;
        accordionTitle: string;
        panel: string;
        apiUrl: string;
    };
    expanded: boolean;
    parentAccordion: string;
    isShowcaseFlow: boolean;
    handleMenuCloseDesignDetail: (isCloseMenu: boolean) => void;
    handleSelectedDesignDetailId: (itemId: string) => void;
    handleMoreItemsClosed: (isCloseMenu: boolean) => void;
    handleActiveAccordion: (activeAccordion: string) => void;
    handleItems: (items: any) => void;
    handleCloseProductDetails: (isCloseMenu: boolean) => void;
    handleSelectedProductDetailId: (itemId: string) => void;
}
export const apiStatusConstants = {
    initial: 'INITIAL',
    pending: 'PENDING',
    fulfilled: 'FULFILLED',
    rejected: 'REJECTED'
}
export const mapProductsToBuilderProducts = (products: RecentAndFavoriteProduct[]): BuilderProduct[] => {
    return products.filter((product) => product.model3dUrl)
        .map((product) => ({
            productId: product.itemId,
            productName: product.name,
            productImage: product.image,
            shopifyId:product.shopifyId,
            productDesignImage: "", // Assuming no equivalent field, set it to an empty string
            productDescription: "", // Assuming no equivalent field, set it to an empty string
            productTypeName: product.type,
            isDefault: "false", // Default value as no equivalent field
            style: "", // Assuming no equivalent field, set it to an empty string
            styleId: "", // Assuming no equivalent field, set it to an empty string
            model3dUrl: product.model3dUrl,
            price: product.price,
            comparePrice: product.comparePrice,
            productDimentions: {
                depth: 40, // Default as no equivalent field
                width: 40, // Default as no equivalent field
                height: 40, // Default as no equivalent field
                weight: 40, // Default as no equivalent field
            },
            isBestSeller: false, // Default value as no equivalent field
            similarProducts: [], // Default empty array
            relatedProducts: [], // Default empty array
            isFromRoomScan: false, // Default value as no equivalent field
            object3D: null, // Default value as no equivalent field
            availability: "Available", // Assuming availability status, set a default
        }));
};
const SubAccordionDetails: React.FC<SubAccordionDetailsProps> = (props) => {
    console.log('SubAccordionDetails start--------------------------------')
    //props
    const { parentAccordion, eachAccordion, expanded, isShowcaseFlow, handleMenuCloseDesignDetail, handleSelectedDesignDetailId, handleMoreItemsClosed, handleActiveAccordion, handleItems, handleCloseProductDetails, handleSelectedProductDetailId } = props
    const { accordionTitle, apiUrl } = eachAccordion
    //utility imports
    const dispatch = useDispatch();

    //states
    const [apiStatus, setApiStatus] = useState<string>(apiStatusConstants.initial);
    const [items, setItems] = useState([])
    //effects
    useEffect(() => {
        //abort controller(to cancel the api call in the middle)
        const controller = new AbortController();
        const signal = controller.signal;

        async function fetchData() {
            setApiStatus(apiStatusConstants.pending)
            //function to make api call
            const makeApiCall = async (url: string) => {
                try {
                    const response = await axios.get(url, { signal });
                    if (response.data) {
                        return response.data
                    } else {
                        throw new Error('error at SubAccordionDetails component while fetching data')
                    }
                } catch (error) {
                    console.log(error, 'error at SubAccordionDetails component while fetching data')
                    setApiStatus(apiStatusConstants.rejected)
                }
            }
            //actual conditions start
            if (accordionTitle === subAccordionConstants.designs) {
                const data: any = await makeApiCall(apiUrl)
                setItems(data.designs.filter((eachDesign: any) => eachDesign.isPersonalizable).map((eachDesign: any) => ({ itemId: eachDesign.designId, image: eachDesign.designImage, name: eachDesign.designName, isPersonalizable: eachDesign.isPersonalizable })))
                setApiStatus(apiStatusConstants.fulfilled)
            } else if (accordionTitle === subAccordionConstants.products) {
                const data: any = await makeApiCall(apiUrl)
                setItems(data.products.filter((eachProduct: any) => eachProduct.model3dUrl))
                dispatch(builderActions.addProductData({ products: data.products.filter((eachProduct: any) => eachProduct.model3dUrl) }))
                setApiStatus(apiStatusConstants.fulfilled)
            } else if (parentAccordion === accordionTitleConstants.designs && (accordionTitle === subAccordionConstants.favorited || accordionTitle === subAccordionConstants.recentlyViewed)) {
                const userId = getUserId()
                const data: any = await makeApiCall(`${apiUrl}&customerId=${userId}`)
                setItems(data);
                setApiStatus(apiStatusConstants.fulfilled);
            } else if (parentAccordion === accordionTitleConstants.products && (accordionTitle === subAccordionConstants.favorited || accordionTitle === subAccordionConstants.recentlyViewed)) {
                const userId = getUserId()
                const data: any = await makeApiCall(`${apiUrl}&customerId=${userId}`)
                const filteredProducts: any = data.filter((eachProduct: any) => eachProduct.model3dUrl)
                setItems(mapProductsToBuilderProducts(filteredProducts) as any);
                dispatch(builderActions.addProductData({ products: mapProductsToBuilderProducts(filteredProducts) }))
                setApiStatus(apiStatusConstants.fulfilled);
            } else if (isShowcaseFlow && (accordionTitle === subAccordionConstants.relatedProducts || accordionTitle === subAccordionConstants.similarProducts)) {
                const data: any = await makeApiCall(apiUrl)
                const key = (accordionTitle === subAccordionConstants.relatedProducts) ? "relatedProducts" : "similarProducts";
                setItems(data[key].map((eachProduct: any) => ({ ...eachProduct, ...eachProduct.productMetaData })));
                dispatch(builderActions.addProductData({ products: data[key].map((eachProduct: any) => ({ ...eachProduct, ...eachProduct.productMetaData })) }))
                setApiStatus(apiStatusConstants.fulfilled);
            } else {
                setApiStatus(apiStatusConstants.rejected)
            }

        }
        if (expanded) {
            fetchData()
        }
        return () => {
            controller.abort(); // Cancel request on cleanup
        };
    }, [expanded, parentAccordion, apiUrl, accordionTitle, isShowcaseFlow])
    //views
    const pendingView = () => {
        return <LoadingSpinner />
    }
    const fulfilledView = () => {
        //handlers of fulfilled view
        const handleSeeMoreDesigns = () => {
            handleActiveAccordion({ parentAccordion, childAccordion: accordionTitle } as any)
            handleItems(items)
            handleMoreItemsClosed(false)
            gtmClickTracking({ event: 'show_all_designs' })
        }
        const handleSeeMoreProducts = () => {
            handleActiveAccordion({ parentAccordion, childAccordion: accordionTitle } as any)
            handleItems(items)
            handleMoreItemsClosed(false)
            gtmClickTracking({ event: 'show_all_products' })
        }
        //views of fulfilled view
        const renderUi = (eachItem: any) => {
            if (parentAccordion === accordionTitleConstants.designs) {
                return <EachDesignCard key={eachItem.itemId} eachDesign={eachItem} handleMenuCloseDesignDetail={handleMenuCloseDesignDetail} handleSelectedDesignDetailId={handleSelectedDesignDetailId} />;
            }
            if (parentAccordion === accordionTitleConstants.products) {
                return <EachProductCard key={eachItem.productId} eachProduct={eachItem} handleCloseProductDetails={handleCloseProductDetails} handleSelectedProductDetailId={handleSelectedProductDetailId} />;
            }
            return null;
        };
        //root return jsx of fulfilled view
        return (
            <>
                {items.length > 0 ? (
                    items.slice(0, 4).map(renderUi)
                ) : <NoItemsMessage textToShow={parentAccordion === accordionTitleConstants.designs ? 'No designs available' : 'No products available'} />}
                {/* see more designs button */}
                {items.length > 4 && (
                    <Box
                        component="div"
                        onClick={parentAccordion === accordionTitleConstants.designs ? handleSeeMoreDesigns : handleSeeMoreProducts}
                        sx={{
                            fontSize: '12px',
                            margin: '0 8px 8px',
                            color: '#0D908E',
                            border: '1px solid #0D908E',
                            borderRadius: '10px',
                            textAlign: 'center',
                            cursor: 'pointer',
                        }}
                    >
                        {parentAccordion === accordionTitleConstants.designs ? '+ See more designs' : "+ See more products"}
                    </Box>
                )}
            </>
        );
    };

    const rejectedView = () => {
        return <NoItemsMessage textToShow={parentAccordion === accordionTitleConstants.designs ? 'No designs available' : 'No products available'} />
    }

    function renderView(apiStatus: string) {
        switch (apiStatus) {
            case apiStatusConstants.pending:
                return pendingView();
            case apiStatusConstants.fulfilled:
                return fulfilledView();
            case apiStatusConstants.rejected:
                return rejectedView()
            default:
                return null;
        }
    }
    //root jsx return
    return <>
        {renderView(apiStatus)}
    </>
}
export default SubAccordionDetails;
